<!-- eslint-disable max-lines -->
<template>
    <paper id="customerPrescription">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :optionNum="optionNum"
            :loading="loading"
            :searchTotalTitle="searchTotalTitle"
            :initSearchInfo="initSearchInfo"
            @saveData="saveData"
            @row-db-click="rowDBclick"
            @getTableConfigList="getTableConfigList"
            @check-btn="checkBtn"
            @edit-btn="editBtn"
            @copy-btn="copyBtn"
            @del-btn="delBtn"
            @switch-change="switchChange"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            searchId="test"
            pageID="test"
        >
            <div slot="table-module-btn">
                <el-tooltip class="item" effect="dark" content="新增" placement="bottom" v-has="'otp06020001'">
                    <el-button size="mini" icon="el-icon-plus" @click="addData"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导入" placement="bottom">
                    <span v-has="'otp06020004'" class="mgl-10">
                    <el-button icon="icon-daoru" size="mini" @click="orderImportC"></el-button>
                    </span>
                </el-tooltip>
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_CUST_AGING">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'otp06020005'" class="mgl-10">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <reportExport #default="{ submit }" reportCode="REPORT_OTP_END_TO_END_AGING">
                    <el-tooltip effect="dark" content="端到端导出" placement="bottom">
                        <span v-has="'06020006'" class="mgl-10">
                        <el-button icon="icon-daochu" size="mini" @click="exportFile(submit)"></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <span v-has="'otp06020002'">
                    <el-button type="primary" @click="redomet(selectData)">停 用</el-button>
                </span>
                <span style="margin-left: 15px;" v-has="'otp06020003'">
                    <el-button type="primary" @click="saveData">启 用</el-button>
                </span>
            </div>
        </m-pane>
        <Import
            ref="Import"
            :ImportConfig="config.table.ImportConfig"
            :ImportContent="ImportContent"
            @getUploadResult="getUploadResult"
        ></Import>
        <aging-dialog v-if="visible" :visible.sync="visible" :rowData="rowData" :btnType="btnType"
            @refresh="refresh">
        </aging-dialog>
    </paper>
</template>
<script>
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

import _ from 'lodash';
import mPane from '@/components/otpPanel';
import config from './config.js';
import paper from '@/components/core/paper/Paper';
import Import from '../../../components/common/Import';
import reportExport from '@/components/lots/reportExportPlugin';
import AgingDialog from './editDialog/AgingDialog';
import { getCustomerList, customerStop, customerStart, getAgingProduct, controlParams } from '../../../api/timeManage';
import { getDictionaryDetailByCode } from '../../../api/common';
import { mapState } from 'vuex';

export default {
    name: 'customerPrescription',
    components: { mPane, paper, Import, reportExport, AgingDialog },
    data() {
        return {
            config: config,
            loading: false,
            dialog: config.dialog,
            optionNum: '',
            totalData: [],
            pageTotal: 0,
            searchTotalTitle: config.searchTotalTitle,
            visible: false,
            current: 0,
            tabList: [{ label: '站点仓库配置' }, { label: '节点时效配置' }],
            tableData: [],
            rowData: {},
            searchParams: {
                pageSize: 10,
                pageNo: 1
            },
            selectData: [],
            ImportContent: [
                {
                    'fileName': '分段时效模板.xlsx',
                    'fileSize': '10.5KB',
                    'downLoadInfo': {
                        'url': ''
                    }
                },
                {
                    'fileName': '端到端时效模板.xlsx',
                    'fileSize': '10.5KB',
                    'downLoadInfo': {
                        'url': ''
                    }
                }
            ],
            exportParams: {},
            isFirstSearch: true,
            btnType: '',
            agingSwitchValue: ''
        };
    },
    methods: {
        _validateSearchParams() {
            const actions = {
                orderType: '订单类型',
                businessMode: '业务模式',
                deliveryType: '配送方式'
            };
            let searchLimitStr = '';
            Object.keys(actions).forEach(key => {
                if (!this.exportParams[key]) searchLimitStr += `${actions[key]} & `;
            });
            searchLimitStr = searchLimitStr.substring(0, searchLimitStr.length - 2);
            if (searchLimitStr) {
                this.exportType = false;
                return `导出时，查询条件 ${searchLimitStr}不能为空`;
            }
        },
        async init() {
            const routerParams = this.$route.params;
            if (routerParams.isRefresh) { // 订单log跳转
                this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].clear();
                const initSearchInfo = {
                    ...routerParams
                };
                this.searchParams = { ...initSearchInfo, pageNo: 1, pageSize: this.searchParams.pageSize };
                delete this.searchParams.receiveTownCodes;
                delete this.searchParams.sendTownCodes;
            }
            await this.getControlParams();
            this.getCustomerList();
        },
        async getControlParams() {
            const params = {
                code: 'AGING_DATA_SWITCHING'
            };
            await controlParams(params).then(res => {
                if (res) {
                    this.agingSwitchValue = _.get(res, 'data.list[0].value', '');
                }
            }).catch(() => {
                this.agingSwitchValue = '';
            });
        },
        getCustomerList() {
            this.isFirstSearch = false;
            getCustomerList(this.searchParams).then(res => {
                if (res && res.code === '0') {
                    res.data.list.map(item => {
                        if (item.receiveTown) {
                            item.receiveTown = `${item.receiveProvince}/${item.receiveCity}/${item.receiveDistrict}/${item.receiveTown}`;
                        }
                        if (item.receiveDistrict && !item.receiveTown) {
                            item.receiveTown = `${item.receiveProvince}/${item.receiveCity}/${item.receiveDistrict}`;
                        }
                        if (item.sendTown) {
                            item.sendTown = `${item.sendProvince}/${item.sendCity}/${item.sendDistrict}/${item.sendTown}`;
                        }
                        if (item.sendDistrict && !item.sendTown) {
                            item.sendTown = `${item.sendProvince}/${item.sendCity}/${item.sendDistrict}`;
                        }
                        item.orderTimes = this.orderTimeChange(item.orderStartTime) + ' ~ ' + this.orderTimeChange(item.orderEndTime);
                        if (!(item.validTime && item.invalidTime) && this.agingSwitchValue === 'Y') {
                            item.hiddenEvent = ['edit'];
                        }
                    });
                    this.totalData = res.data.list || [];
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        orderTimeChange(time) {
            if (time) return time.replace('-', '(前一天)');
            return '';
        },
        getUploadResult(flag) {
            if (flag) {
                this.getCustomerList();
            }
        },
        setTimeOption(round, ms) {
            const arr = [];
            for (let i = 0; i < round; i++) {
                if (i <= 23) {
                    if (i < 10) {
                        arr.push({
                            label: `0${i % 24}:${ms}:${ms}`,
                            value: `0${i % 24}:${ms}:${ms}`
                        });
                    } else {
                        arr.push({
                            label: `${i % 24}:${ms}:${ms}`,
                            value: `${i % 24}:${ms}:${ms}`
                        });
                    }
                } else {
                    if (i % 24 < 9) {
                        arr.push({
                            label: `(前一天) 0${i % 24}:${ms}:${ms}`,
                            value: `-0${i % 24}:${ms}:${ms}`
                        });
                    } else {
                        arr.push({
                            label: `(前一天) ${i % 24}:${ms}:${ms}`,
                            value: `-${i % 24}:${ms}:${ms}`
                        });
                    }
                }
            }
            return arr;
        },
        setBeginOption() {
            this.config.dialog.dialogForm.inputList.map(item => {
                if (item.value === 'orderStartTime') {
                    item.options = this.setTimeOption(48, '00');
                }
                if (item.value === 'orderEndTime') {
                    item.options = this.setTimeOption(24, '59');
                }
                if (item.value === 'agingStartTime') {
                    item.options = [...this.setTimeOption(24, '00'), {
                        label: '(第二天) 00:00:00',
                        value: '+00:00:00'
                    }];
                }
            });
            this.config.searchTotalTitle.map(item => {
                if (item.value === 'orderStartTime') {
                    item.options = this.setTimeOption(48, '00');
                }
                if (item.value === 'orderEndTime') {
                    item.options = this.setTimeOption(24, '59');
                }
                if (item.value === 'agingStartTime') {
                    item.options = [...this.setTimeOption(24, '00'), {
                        label: '(第二天) 00:00:00',
                        value: '+00:00:00'
                    }];
                }
            });
        },
        rowDBclick(row) {
            this.rowData = row;
            this.checkBtn(row);
        },
        initBtnClick(data, type) { // 初始化配置文件
            this.rowData = data;
            this.visible = true;
            this.btnType = type;
            const dialog = this.config.dialog;
            dialog.dialogForm.inputList.forEach(item => {
                item.readOnly = !['copy', 'edit', 'add'].includes(type);
                item.placeholder = ['copy', 'edit', 'add'].includes(type) ? '' : ' ';
                if (item.type === 'advance') {
                    item.name = ['copy', 'edit', 'add'].includes(type) ? item.label : ' ';
                }
            });
            dialog.btnList = ['copy', 'edit', 'add'].includes(type)
                ? [{ 'type': 'negative', 'text': '取消' }, { 'type': 'sure', 'text': '确定' }]
                : [{ 'type': 'negative', 'text': '取消' }];
            dialog.agingConfigTable1.btnActive = dialog.agingConfigTable.btnActive = ['copy', 'edit', 'add'].includes(type);
        },
        checkBtn(data) {
            this.initBtnClick(data, 'check');
        },
        copyBtn(data) {
            this.initBtnClick(data, 'copy');
        },
        editBtn(data) {
            this.initBtnClick(data, 'edit');
            if (data.enableFlag) { this.redomet([data]); }
        },
        delBtn(data) {
            // 表格内按钮删除事件;
        },
        selectChange(data) {
            // 表格内选择变化
            this.selectData = data;
        },
        switchChange(data) {
            // 表格内switch切换事件
        },
        searchChange(data) {
            // 提交搜索框
            if (data.receiveTownCodes && data.receiveTownCodes.length) {
                [data.receiveProvinceCode, data.receiveCityCode, data.receiveDistrictCode, data.receiveTownCode] = data.receiveTownCodes;
            } else {
                [data.receiveProvinceCode, data.receiveCityCode, data.receiveDistrictCode, data.receiveTownCode] = ['', '', '', ''];
            }
            if (data.sendTownCodes && data.sendTownCodes.length) {
                [data.sendProvinceCode, data.sendCityCode, data.sendDistrictCode, data.sendTownCode] = data.sendTownCodes;
            } else {
                [data.sendProvinceCode, data.sendCityCode, data.sendDistrictCode, data.sendTownCode] = ['', '', '', ''];
            }
            const key = Object.keys(data);
            key.map(item => {
                if (!data[key]) {
                    delete data[key];
                }
            });
            delete data.customerName;
            this.searchParams = { ...this.searchParams, ...data, pageNo: 1 };
            delete this.searchParams.receiveTownCodes;
            delete this.searchParams.sendTownCodes;
            this.exportParams = { ...this.searchParams };
            this.getCustomerList();
        },
        pageChange(data) {
            // 分页器页数变化
            this.searchParams.pageNo = data;
            this.getCustomerList();
        },
        sizeChange(data) {
            // 分页器页数大小变化
            this.searchParams.pageSize = data;
            this.getCustomerList();
        },
        addData() {
            this.initBtnClick({}, 'add');
            this.formValue = {
                customerAgingType: 'ANNTO_AGING'
            };
            this.tableData = [];
        },
        saveData(data) {
            const noCanEnabled = [];
            const idList = [];
            this.selectData.map(item => {
                if (!(item.validTime && item.invalidTime)) noCanEnabled.push(item.customerAgingCode);
                idList.push(item.id);
            });
            if (noCanEnabled.length) return this.$message.warning(`${noCanEnabled.join('，')} 为以前的分段时效，不再支持启用`);
            customerStart(idList).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('启用成功');
                    this.getCustomerList();
                }
            });
        },
        redomet(selectData) {
            // 这是删除方法
            const idList = [];
            selectData.map(item => {
                idList.push(item.id);
            });
            customerStop(idList).then(res => {
                if (res && res.code === '0') {
                    this.$message.success('停用成功');
                    this.getCustomerList();
                }
            });
        },
        getTableConfigList(data) {},
        refresh() {
            this.getCustomerList();
        },
        orderImportC() {
            this.$refs.Import.orderImportC();
        },
        getDictList() {
            getDictionaryDetailByCode({ dictCodes: 'FORMWORK_OTP' }).then(res => {
                if (res) {
                    this.ImportContent[0].downLoadInfo.url = _.get(res, 'data.FORMWORK_OTP.ORDER_AGING', '');
                    this.ImportContent[1].downLoadInfo.url = _.get(res, 'data.FORMWORK_OTP.CHAIN_ORDER_AGING', '');
                }
            });
        },
        // 导出
        exportFile(submit) {
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            if (this._validateSearchParams()) return this.$message.warning(this._validateSearchParams());
            submit({
                ...this.exportParams,
                tenantCode: this.currentTenant.tenantCode,
                beginDate2: '2020-11-26 00:00:00', // 没有的字段，为了后端导出任务片段必填
                endDate2: '2020-11-27 00:00:00'
            });
            this.isFirstSearch = false;
        }
    },
    mounted() {
        // 初始化时效产品的下拉框选项
        const agingProductSearchItem = this.config.searchTotalTitle.find(item => item.value === 'agingProduct');
        const agingProductFormItem = this.config.dialog.dialogForm.inputList.find(item => item.value === 'agingProduct');
        getAgingProduct({
            pageNo: 1,
            pageSize: 9999
        }).then(res => {
            if (res && res.code === '0') {
                agingProductSearchItem.options = agingProductFormItem.options = res.data.list.filter(item => item.agingProductType === 'STANDARD').map(item => {
                    return {
                        label: item.agingProductName,
                        value: item.agingProductCode
                    };
                });
            }
        });
        this.init();
        this.setBeginOption();
        this.getDictList();
    },
    computed: {
        ...mapState({
            currentTenant: state => state.currentTenant
        }),
        initSearchInfo() {
            const routerParams = this.$route.params || {};
            const initSearchInfo = {
                ...this.searchParams,
                receiveTownCodes: [routerParams.receiveProvinceCode, routerParams.receiveCityCode],
                sendTownCodes: [routerParams.sendProvinceCode, routerParams.sendCityCode]
            };
            // 跳转过来，重置无法删除显示的四级地址
            if (!this.searchParams.receiveProvinceCode) { delete initSearchInfo.receiveTownCodes; }
            if (!this.searchParams.sendProvinceCode) { delete initSearchInfo.sendTownCodes; }
            return { ...initSearchInfo };
        }
    },
    activated() {
        if (this.$route.params.isRefresh) {
            this.init();
        }
    }
};
</script>
<style lang="less">
#customerPrescription {
    .model-table-search {
        white-space: nowrap;
    }
    .tableHeader {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        .tagList {
            flex: 1;
            display: flex;
            .active {
                color: #00bcbf;
                border-bottom: 2px solid #00bcbf;
                box-sizing: border-box;
            }
            .tag {
                text-align: center;
                font-size: 13px;
                width: 120px;
                height: 100%;
                p {
                    line-height: 40px;
                    margin: 0;
                }
            }
        }
    }
    .tableFooter {
        text-align: center;
        width: 100%;
        padding: 3px 0;
        border-bottom: 1px solid #eee;
    }
    .aging-tab {
        .el-tabs__header {
            padding: 0 15px;
            margin-bottom: 0;
        }
        .dialogTable {
            padding: 0;
        }
    }
    .aging-config {
        padding: 0 15px;
    }
    .total-elapsed-time {
        margin-right: 20px;
    }
    .aging-collapse {
        .el-collapse-item__content {
            padding-bottom: 0;
        }
        .el-table__header-wrapper, .el-table__fixed-header-wrapper {
            display: none;
        }
        .el-collapse-item__header {
            height: 32px;
            line-height: 32px;
            padding-left: 10px;
            font-size: 14px;
            background: #f6f6f7;
        }
        .aging-config-header {
            flex: 1;
            display: flex;
            justify-content: space-between;
        }
    }
}
</style>
